import axios from 'axios';
import { invalidTokenCodeArr } from '../consts';

function getUrl() {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8083/userservice';
  }

  return '/userservice';
}

function loadBaseUrl() {
  axios.defaults.baseURL = getUrl();
}

function setAuthToken(value) {
  axios.defaults.headers.common.authorization = `Bearer ${value}`;
}

function removeAuthToken() {
  axios.defaults.headers.common.authorization = null;
}

function setInvalidatedTokenCallback(callback) {
  axios.interceptors.response.use((response) => response, (error) => {
    if (error.response && (invalidTokenCodeArr.includes(error.response.data.code))) {
      callback();
    }

    return Promise.reject(error);
  });
}

export {
  loadBaseUrl, setAuthToken, removeAuthToken, setInvalidatedTokenCallback
};
